import { Box } from "@mui/material";
import Sidebar from "../../components/sidebar/Sidebar";
import Header from "../../components/header/Header";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import PaymentIcon from "@mui/icons-material/Payment";

const SAPDashboardLayout = ({ children }) => {
  const headerHeight = 70;
  const childrenHeaderHeight = 70;
  const sidebarWidth = 150;

  const menuItems = [
    { text: "Dashboard", icon: <HomeOutlinedIcon />, path: "/sap/dashboard" },
    { text: "Courses", icon: <MenuBookOutlinedIcon />, path: "/sap/courses" },
    // { text: "Report", icon: <AssignmentOutlinedIcon />, path: "/sap/report" },
    {
      text: "Timeline",
      icon: <AccessTimeOutlinedIcon />,
      path: "/sap/timeline",
    },
    {
      text: "Applications",
      icon: <ArticleOutlinedIcon />,
      path: "/sap/applications",
    },
    {
      text: "Documents",
      icon: <DescriptionOutlinedIcon />,
      path: "/sap/documents",
    },
    {
      text: "Payment History",
      icon: <PaymentIcon />,
      path: "/sap/payment-history",
    },

    {
      text: "Pricing Plan",
      icon: <FavoriteBorderOutlinedIcon />,
      path: "/sap/pricing-plan",
    },
  ];

  return (
    <Box sx={{ display: "flex" }}>
      {/* Sidebar */}
      <Box
        sx={{
          zIndex: 1,
          width: sidebarWidth,
          flexShrink: 0,
          position: "fixed",
          top: headerHeight,
          left: 0,
          bottom: 0,
          bgcolor: "#FBF5FF",
          borderRight: "1px solid #eee",
          overflowY: "auto",
          overflowX: "hidden",

          /* Hide scrollbar for Chrome, Safari, Edge */
          "&::-webkit-scrollbar": {
            display: "none",
          },
          /* Hide scrollbar for Firefox */
          scrollbarWidth: "none",
          /* Hide scrollbar for IE/Edge */
          msOverflowStyle: "none",
        }}
      >
        <Sidebar menuItems={menuItems} />
      </Box>

      <Box sx={{ flex: 1, ml: `${sidebarWidth}px` }}>
        {/* Header */}
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            height: headerHeight,
            bgcolor: "white",
            borderBottom: "1px solid #eee",
            zIndex: 1000,
          }}
        >
          <Header />
        </Box>

        {/* Dynamic Page Content */}
        <Box
          sx={{
            mt: `${childrenHeaderHeight}px`,
            p: 4,
            minHeight: "100vh",
            bgcolor: "#fafafa",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default SAPDashboardLayout;
